import { Button, Checkbox, Col, Form, Input, Row, Select, Tooltip } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

const FormFilter = ({ form, submit, loading }) => {
  const { t } = useTranslation()

  const onFinish = () => {
    submit()
  }

  return (
    <>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="areaManager" label={t('departmentManager')}>
              <Input style={{ width: '200px' }} placeholder={t('departmentManager')} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="firstName" label={t('firstName')}>
              <Input style={{ width: '200px' }} placeholder={t('firstName')} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="lastName" label={t('lastName')}>
              <Input style={{ width: '200px' }} placeholder={t('lastName')} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="code" label={t('code')}>
              <Input style={{ width: '200px' }} placeholder={t('code')} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="unregistered" label={t('unregistered')} valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={2}>
            <Form.Item>
              <Tooltip title={t('search')}>
                <Button loading={loading} style={{ width: "100%" }} htmlType="submit" type="primary">
                  <SearchOutlined />
                </Button>
              </Tooltip>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormFilter;
